export function formatPrices(prices) {
  let cloneArray = [...prices];
  cloneArray.forEach(item => {
    item.beer = parseFloat(item.beer);
    item.wine = parseFloat(item.wine);
    item.cocktail = parseFloat(item.cocktail);
  });
  return cloneArray;
}

const bar = {
  _id: "",
  name: "",
  description: "",
  hours: [
    {
      day: "Mon",
      open: "",
      close: ""
    },
    {
      day: "Tue",
      open: "",
      close: ""
    },
    {
      day: "Wed",
      open: "",
      close: ""
    },
    {
      day: "Thu",
      open: "",
      close: ""
    },
    {
      day: "Fri",
      open: "",
      close: ""
    },
    {
      day: "Sat",
      open: "",
      close: ""
    },
    {
      day: "Sun",
      open: "",
      close: ""
    }
  ],
  address: {
    EN: "",
    CH: ""
  },
  imageURLs: [{ url: "", description: "" }],
  dailySpecials: [
    {
      name: "",
      day: "Mon",
      description: "",
      selected: false,
      imageURL: ""
    },
    {
      name: "",
      day: "Tue",
      description: "",
      selected: false,
      imageURL: ""
    },
    {
      name: "",
      day: "Wed",
      description: "",
      selected: false,
      imageURL: ""
    },
    {
      name: "",
      day: "Thu",
      description: "",
      selected: false,
      imageURL: ""
    },
    {
      name: "",
      day: "Fri",
      description: "",
      selected: false,
      imageURL: ""
    },
    {
      name: "",
      day: "Sat",
      description: "",
      selected: false,
      imageURL: ""
    },
    {
      name: "",
      day: "Sun",
      description: "",
      selected: false,
      imageURL: ""
    }
  ],
  happyHours: [
    {
      day: "Mon",
      description: "",
      startTime: "",
      endTime: "",
      selected: false,
      imageURL: ""
    },
    {
      day: "Tue",
      description: "",
      startTime: "",
      endTime: "",
      selected: false,
      imageURL: ""
    },
    {
      day: "Wed",
      description: "",
      startTime: "",
      endTime: "",
      selected: false,
      imageURL: ""
    },
    {
      day: "Thu",
      description: "",
      startTime: "",
      endTime: "",
      selected: false,
      imageURL: ""
    },
    {
      day: "Fri",
      description: "",
      startTime: "",
      endTime: "",
      selected: false,
      imageURL: ""
    },
    {
      day: "Sat",
      description: "",
      startTime: "",
      endTime: "",
      selected: false,
      imageURL: ""
    },
    {
      day: "Sun",
      description: "",
      startTime: "",
      endTime: "",
      selected: false,
      imageURL: ""
    }
  ],
  prices: [
    { name: "Normal", beer: 0, wine: 0, cocktail: 0 },
    { name: "Happy Hour", beer: 0, wine: 0, cocktail: 0 }
  ],
  featured: false
};

export const defaultBar = Object.freeze(bar);
